import styled from 'styled-components';

export const Content = styled.main`
  box-sizing: border-box;
  position: relative;
  grid-column: 2/3;
  overflow: hidden;
`;